import { forwardRef } from "react";

import { Form } from "@shared/components/Form";

import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getBookCategoriesService } from "@modules/bookCategories/services/queries/listBookCategories/service";

export const BookCategoriesAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      queryHook={getBookCategoriesService}
    />
  );
});

BookCategoriesAutocomplete.displayName = "BookCategoriesAutocomplete";
